import React from 'react'
import { formatValue } from '@fs/zion-locale'
import { Ellipsis } from '@fs/zion-ui'
import { string, shape, oneOfType, number, func, object } from 'prop-types'
import { calcScaledFontSize } from '../../helpers/styles_helper'

const spanCss = { display: 'block', textAlign: 'center', lineHeight: '21px', width: '6.5rem' }

export const NameBlock = ({ person = {}, css: customCSS }) => {
  // Extract the first name from the full name
  const fullName = person.userProfileName || ''
  const firstName = fullName.split(' ')[0]
  const adjustedSize = calcScaledFontSize(firstName.length, 0.8, 1.125, 6, 12)

  // Format points only if they exist, otherwise use an empty string
  const formattedPoints = person?.points !== undefined ? formatValue(person.points) : ''

  return (
    <div css={customCSS} data-testid="name-block">
      <span style={{ fontWeight: 'bold', fontSize: `${adjustedSize}rem`, ...spanCss }}>
        <Ellipsis data-testid="name-value">{firstName}</Ellipsis>
      </span>
      <span style={{ fontSize: '1rem', ...spanCss }} data-testid="points-value">
        {formattedPoints}
      </span>
    </div>
  )
}

NameBlock.propTypes = {
  person: shape({
    userProfileName: string,
    points: number,
  }),
  css: oneOfType([func, object, string]),
}
